(() => {
  let resolveBookingReady = null;
  const bookingReadyPromise = new Promise((resolve) => {
    resolveBookingReady = resolve;
  });
  window.PITBBookingReady = bookingReadyPromise;

  const cfg = window.PITB_ENTRY_FEE || {};
  const catalogRoot = window.PITB_BOOKING_CATALOG || {};
  const DATE_DEFAULT = cfg.dateDefault || '';
  const DATE_END = cfg.dateEnd || '';
  const pickupPolicy = window.PITBPickupPolicy;
  const TICKET_PRICE = Number(cfg.ticketPrice) || 13;
  const FEE_HANDLE = cfg.handle || 'tff-sg-popup-2026';
  const TICKET_HANDLE = cfg.ticketHandle || FEE_HANDLE;
  const SELF_COLLECT_HANDLE = cfg.selfCollectHandle || '';
  const EVENT_HANDLE = cfg.handle || cfg.ticketHandle || TICKET_HANDLE;
  const LEGACY_FEE_HANDLE = cfg.legacyHandle || 'pitb-sg-popup-entry-fee';
  let ISO_BY_LABEL = { ...(cfg.isoByDateLabel || {}) };
  let LABEL_BY_ISO = { ...(cfg.dateLabelByIso || {}) };

  const collectionModeFromDom = () => {
    const page = document.querySelector('[data-pitb-cart-page]');
    const method = page && page.getAttribute('data-pitb-collection');
    return method === 'self_collect' ? 'self_collect' : 'event';
  };

  let activeMode = collectionModeFromDom();

  const activeCatalog = () => catalogRoot[activeMode] || catalogRoot.event || {};

  const catalogHandleForMode = (mode = activeMode) => {
    if (mode === 'self_collect') {
      return (
        (catalogRoot.self_collect && catalogRoot.self_collect.handle) ||
        SELF_COLLECT_HANDLE ||
        'self-collect-only'
      );
    }
    return (catalogRoot.event && catalogRoot.event.handle) || EVENT_HANDLE || 'tff-sg-popup-2026';
  };

  const catalogHandlesToTry = (mode = activeMode) => {
    const cat = catalogRoot[mode] || {};
    const fallbacks =
      mode === 'self_collect'
        ? ['self-collect-only', SELF_COLLECT_HANDLE]
        : ['tff-sg-popup-2026', 'pitb-sg-popup-24-sep-2026', EVENT_HANDLE, TICKET_HANDLE, FEE_HANDLE];
    const fromCatalog = Array.isArray(cat.fallbackHandles) ? cat.fallbackHandles : [];
    return [...new Set([cat.handle, catalogHandleForMode(mode), ...fromCatalog, ...fallbacks].filter(Boolean))];
  };

  const selfCollectVariantIds = () => {
    const cat = catalogRoot.self_collect || {};
    return Object.values(cat.ticketSpotByKey || {}).map(String);
  };

  const isSelfCollectItem = (item) => {
    if (!item) return false;
    const handle = String(item.handle || item.product_handle || '').toLowerCase();
    const variantId = String(item.variant_id || '');
    const selfCollectVariants = selfCollectVariantIds();
    if (SELF_COLLECT_HANDLE && handle === SELF_COLLECT_HANDLE.toLowerCase()) return true;
    if (selfCollectVariants.includes(variantId)) return true;
    return handle.includes('self-collect-only');
  };

  const isBookingLine = (item) => isFeeItem(item) || isSelfCollectItem(item);

  const allRoots = () => Array.from(document.querySelectorAll('[data-pitb-booking]'));

  if (!allRoots().length && !document.querySelector('cart-drawer') && !document.getElementById('main-cart-items')) {
    return;
  }

  const statusEls = () => Array.from(document.querySelectorAll('[data-pitb-booking-status]'));

  const normalizeSlot = (value) => String(value || '').trim();

  const normalizeDate = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;
    if (ISO_BY_LABEL[raw]) return ISO_BY_LABEL[raw];
    const cleaned = raw.replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    const noOrdinal = cleaned.replace(/\b(\d{1,2})(st|nd|rd|th)\b/gi, '$1');
    const monthNames = {
      january: '01', jan: '01',
      february: '02', feb: '02',
      march: '03', mar: '03',
      april: '04', apr: '04',
      may: '05',
      june: '06', jun: '06',
      july: '07', jul: '07',
      august: '08', aug: '08',
      september: '09', sep: '09',
      october: '10', oct: '10',
      november: '11', nov: '11',
      december: '12', dec: '12',
    };
    const pad = (n) => String(n).padStart(2, '0');
    const toIso = (year, month, day) => {
      const m = monthNames[String(month || '').toLowerCase()];
      const d = Number(day);
      const y = Number(year);
      if (!m || !Number.isFinite(d) || !Number.isFinite(y)) return '';
      return `${y}-${m}-${pad(d)}`;
    };
    const parts = noOrdinal.split(' ').filter(Boolean);
    if (parts.length >= 3) {
      const maybeDay = parts[parts.length - 3];
      const maybeMonth = parts[parts.length - 2];
      const maybeYear = parts[parts.length - 1];
      if (/^\d{4}$/.test(maybeYear)) {
        if (/^\d{1,2}$/.test(maybeDay) && monthNames[String(maybeMonth).toLowerCase()]) {
          return toIso(maybeYear, maybeMonth, maybeDay);
        }
        if (/^\d{1,2}$/.test(maybeMonth) && monthNames[String(maybeDay).toLowerCase()]) {
          return toIso(maybeYear, maybeDay, maybeMonth);
        }
      }
    }
    const mdy = noOrdinal.match(/^([A-Za-z]+)\s+(\d{1,2})\s+(\d{4})$/);
    if (mdy) return toIso(mdy[3], mdy[1], mdy[2]);
    const dmy = noOrdinal.match(/^(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})$/);
    if (dmy) return toIso(dmy[3], dmy[2], dmy[1]);
    return '';
  };

  const isIsoDate = (value) => /^\d{4}-\d{2}-\d{2}$/.test(String(value || '').trim());

  const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const isoFromParts = (year, month, day) =>
    `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

  const pickupDateIsStale = (iso) => {
    const date = normalizeDate(iso);
    if (!date) return false;
    return !pickupPolicy.isIsoDate(date) || date < pickupPolicy.earliestPickupDate();
  };

  const earliestSelectableIso = (configuredMin = '') => {
    const min = normalizeDate(configuredMin);
    const floor = pickupPolicy.earliestPickupDate();
    if (!min) return floor || '';
    if (floor && floor > min) return floor;
    return min;
  };

  const monthKeyFromIso = (iso) => String(iso || '').slice(0, 7);

  const formatTicketPrice = (price) => {
    const n = Number(price);
    if (!Number.isFinite(n)) return '';
    return n.toFixed(2);
  };

  const getSlotKeys = (root) =>
    Array.from(root.querySelectorAll('[data-pitb-slot-option]')).map((el) =>
      normalizeSlot(el.getAttribute('data-pitb-slot-option'))
    );

  const isInEventRange = (iso, min, max) => {
    if (!iso) return false;
    if (min && iso < min) return false;
    if (max && iso > max) return false;
    return true;
  };

  const catalogDateBounds = (mode = activeMode) => {
    const cat = catalogRoot[mode] || {};
    const isos = [];
    const push = (value) => {
      const iso = normalizeDate(value);
      if (isIsoDate(iso)) isos.push(iso);
    };
    push(cat.dateMin);
    push(cat.dateMax);
    (cat.availableDates || []).forEach(push);
    Object.keys(cat.dateLabelByIso || {}).forEach(push);
    Object.values(cat.isoByDateLabel || {}).forEach(push);
    if (mode === activeMode) {
      Object.keys(LABEL_BY_ISO || {}).forEach(push);
      Object.values(ISO_BY_LABEL || {}).forEach(push);
    }
    Object.keys(cat.ticketSpotByKey || {}).forEach((key) => {
      push(String(key).split('|')[0] || '');
    });
    const root = allRoots()[0];
    if (root) {
      const isSelf = mode === 'self_collect';
      csvDates(isSelf ? root.dataset.pitbDatesSelf : root.dataset.pitbDatesEvent).forEach(push);
    }
    if (!isos.length) {
      return {
        min: cat.dateMin || (mode === 'event' ? DATE_DEFAULT : '') || '',
        max: cat.dateMax || (mode === 'event' ? DATE_END : '') || '',
      };
    }
    isos.sort();
    return { min: isos[0], max: isos[isos.length - 1] };
  };

  const dateBoundsFromRoot = (root) => {
    const bounds = catalogDateBounds();
    const hidden = root && root.querySelector('[data-pitb-pickup-date]');
    const hiddenMin = hidden && hidden.dataset.pitbDateMin;
    const hiddenMax = hidden && hidden.dataset.pitbDateMax;
    let configuredMin = bounds.min || hiddenMin || DATE_DEFAULT || '';
    let configuredMax = bounds.max || hiddenMax || DATE_END || '';
    if (hiddenMin && (!configuredMin || hiddenMin < configuredMin)) configuredMin = hiddenMin;
    if (hiddenMax && (!configuredMax || hiddenMax > configuredMax)) configuredMax = hiddenMax;
    if (bounds.min && (!configuredMin || bounds.min < configuredMin)) configuredMin = bounds.min;
    if (bounds.max && (!configuredMax || bounds.max > configuredMax)) configuredMax = bounds.max;
    const allowed = availableDatesSet();
    if (allowed && allowed.size) {
      const sorted = [...allowed].sort();
      if (!configuredMin || sorted[0] < configuredMin) configuredMin = sorted[0];
      if (!configuredMax || sorted[sorted.length - 1] > configuredMax) {
        configuredMax = sorted[sorted.length - 1];
      }
    }
    return {
      min: earliestSelectableIso(configuredMin),
      max: configuredMax,
    };
  };

  const calendarMonthBounds = (root) => {
    const { min, max } = dateBoundsFromRoot(root);
    let minMonth = monthKeyFromIso(min);
    let maxMonth = monthKeyFromIso(max);
    const allowed = availableDatesSet();
    if (allowed && allowed.size) {
      const sorted = [...allowed]
        .sort()
        .filter((iso) => (!min || iso >= min) && (!max || iso <= max));
      if (sorted.length) {
        minMonth = monthKeyFromIso(sorted[0]);
        maxMonth = monthKeyFromIso(sorted[sorted.length - 1]);
      }
    }
    return { minMonth, maxMonth };
  };

  const csvDates = (raw) =>
    String(raw || '')
      .split(/[,\s]+/)
      .map((part) => normalizeDate(part))
      .filter(isIsoDate);

  const csvSlots = (raw) =>
    String(raw || '')
      .split(',')
      .map((part) => normalizeSlot(part))
      .filter(Boolean);

  const bookingRootDataset = (mode = activeMode) => {
    const root = allRoots()[0];
    if (!root) return { dates: [], slots: [] };
    const isSelf = mode === 'self_collect';
    return {
      dates: csvDates(isSelf ? root.dataset.pitbDatesSelf : root.dataset.pitbDatesEvent),
      slots: csvSlots(isSelf ? root.dataset.pitbSlotsSelf : root.dataset.pitbSlotsEvent),
    };
  };

  const mergeIsoLists = (...lists) => {
    const set = new Set();
    lists.forEach((list) => {
      (list || []).forEach((entry) => {
        const iso = normalizeDate(entry);
        if (isIsoDate(iso)) set.add(iso);
      });
    });
    return [...set].sort();
  };

  const applyCatalogMode = (mode) => {
    activeMode = mode === 'self_collect' ? 'self_collect' : 'event';
    if (!catalogRoot[activeMode]) catalogRoot[activeMode] = {};
    const cat = catalogRoot[activeMode];
    window.PITB_TICKET_REMAINING = { ...(cat.ticketRemaining || {}) };
    ISO_BY_LABEL = { ...(cat.isoByDateLabel || {}) };
    LABEL_BY_ISO = { ...(cat.dateLabelByIso || {}) };
    if (window.PITB_ENTRY_FEE && activeMode === 'event') {
      window.PITB_ENTRY_FEE.ticketSpotByKey = { ...(cat.ticketSpotByKey || {}) };
    }
    const fromDom = bookingRootDataset(activeMode);
    const listed = mergeIsoLists(cat.availableDates, fromDom.dates);
    if (listed.length) {
      cat.availableDates = listed;
      if (!cat.dateMin || listed[0] < cat.dateMin) cat.dateMin = listed[0];
      if (!cat.dateMax || listed[listed.length - 1] > cat.dateMax) {
        cat.dateMax = listed[listed.length - 1];
      }
    }
    const bounds = catalogDateBounds(activeMode);
    const slots = (
      Array.isArray(cat.slots) && cat.slots.length ? cat.slots : fromDom.slots
    ).map(normalizeSlot).filter(Boolean);
    allRoots().forEach((root) => {
      const hidden = root.querySelector('[data-pitb-pickup-date]');
      if (hidden) {
        hidden.dataset.pitbDateMin = bounds.min || cat.dateMin || listed[0] || '';
        hidden.dataset.pitbDateMax = bounds.max || cat.dateMax || listed[listed.length - 1] || '';
        if (listed.length) hidden.setAttribute('data-pitb-available-dates', listed.join(','));
      }
    });
    return { listed, slots };
  };

  applyCatalogMode(activeMode);

  const availableDatesFromDom = (mode = activeMode) => {
    const fromRoot = bookingRootDataset(mode).dates;
    if (fromRoot.length) return fromRoot;
    const dates = [];
    document.querySelectorAll('[data-pitb-pickup-date]').forEach((hidden) => {
      csvDates(hidden.getAttribute('data-pitb-available-dates')).forEach((iso) => dates.push(iso));
    });
    return dates;
  };

  const availableDatesSet = () => {
    const cat = activeCatalog();
    const listed = Array.isArray(cat.availableDates) ? cat.availableDates : [];
    const fromList = listed.map((iso) => normalizeDate(iso)).filter(isIsoDate);
    const fromLabels = Object.keys(cat.dateLabelByIso || {})
      .map((iso) => normalizeDate(iso))
      .filter(isIsoDate);
    const fromCfg = Object.keys(LABEL_BY_ISO || {})
      .map((iso) => normalizeDate(iso))
      .filter(isIsoDate);
    const fromDom = availableDatesFromDom(activeMode);
    const merged = [...new Set([...fromList, ...fromLabels, ...fromCfg, ...fromDom])];
    if (merged.length) return new Set(merged);
    const keys = Object.keys(cat.ticketSpotByKey || {});
    if (keys.length) {
      const fromKeys = keys
        .map((key) => normalizeDate(String(key).split('|')[0] || ''))
        .filter(isIsoDate);
      if (fromKeys.length) return new Set(fromKeys);
    }
    return null;
  };

  const mergeCatalogDates = (dateSet, cat) => {
    if (!cat || !dateSet) return;
    (cat.availableDates || []).forEach((entry) => {
      const iso = normalizeDate(entry);
      if (isIsoDate(iso)) dateSet.add(iso);
    });
    Object.keys(cat.dateLabelByIso || {}).forEach((entry) => {
      const iso = normalizeDate(entry);
      if (isIsoDate(iso)) dateSet.add(iso);
    });
    Object.values(cat.isoByDateLabel || {}).forEach((entry) => {
      const iso = normalizeDate(entry);
      if (isIsoDate(iso)) dateSet.add(iso);
    });
  };

  const isDateSelectable = (iso, root) => {
    const { min, max } = dateBoundsFromRoot(root);
    if (!isInEventRange(iso, min, max)) return false;
    const allowed = availableDatesSet();
    if (allowed && !allowed.has(iso)) return false;
    if (pickupDateIsStale(iso)) return false;
    if (isDateSoldOut(iso)) return false;
    return true;
  };

  const isDateSoldOut = (iso) => {
    if (!isIsoDate(iso)) return false;
    const cat = activeCatalog();
    const remaining = cat.ticketRemaining || window.PITB_TICKET_REMAINING || {};
    const spotMap = cat.ticketSpotByKey || {};
    const dateKeys = Object.keys(spotMap).filter(
      (key) => normalizeDate(String(key).split('|')[0] || '') === iso
    );
    const allowed = availableDatesSet();
    if (allowed && allowed.has(iso) && !dateKeys.length) return false;

    if (dateKeys.length) {
      const tracked = dateKeys.filter((key) =>
        Object.prototype.hasOwnProperty.call(remaining, key)
      );
      if (!tracked.length) return false;
      return tracked.every((key) => {
        const left = Number(remaining[key]);
        return Number.isFinite(left) ? left <= 0 : true;
      });
    }

    const slots = (cat.slots || []).map((entry) => normalizeSlot(entry)).filter(Boolean);
    if (!slots.length) return false;

    const listed = (cat.availableDates || []).map((entry) => normalizeDate(entry)).filter(isIsoDate);
    if (listed.length && !listed.includes(iso)) return false;
    if (allowed && allowed.has(iso)) return false;

    return slots.every((slot) => {
      const key = Object.keys(spotMap).find((candidate) => {
        const parts = String(candidate).split('|');
        return (
          normalizeDate(parts[0] || '') === iso &&
          normalizeSlot(parts[1] || '') === slot
        );
      });
      if (!key || !Object.prototype.hasOwnProperty.call(remaining, key)) return false;
      const left = Number(remaining[key]);
      return Number.isFinite(left) ? left <= 0 : true;
    });
  };

  const eventMonthKeys = (root) => {
    const { min, max } = dateBoundsFromRoot(root);
    const minM = monthKeyFromIso(min);
    const maxM = monthKeyFromIso(max);
    const months = [];
    let [year, month] = minM.split('-').map(Number);
    const [endYear, endMonth] = maxM.split('-').map(Number);
    while (year < endYear || (year === endYear && month <= endMonth)) {
      months.push(`${year}-${String(month).padStart(2, '0')}`);
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    }
    return months;
  };

  const shiftMonthKey = (monthKey, delta) => {
    let [year, month] = monthKey.split('-').map(Number);
    month += delta;
    if (month > 12) {
      month = 1;
      year += 1;
    } else if (month < 1) {
      month = 12;
      year -= 1;
    }
    return `${year}-${String(month).padStart(2, '0')}`;
  };

  const clampMonthKey = (monthKey, minKey, maxKey) => {
    const key = String(monthKey || '').trim();
    const min = String(minKey || '').trim();
    const max = String(maxKey || '').trim();
    if (!key) return min || max || monthKeyFromIso(pickupPolicy.earliestPickupDate());
    if (min && key < min) return min;
    if (max && key > max) return max;
    return key;
  };

  const defaultViewMonth = (root) => {
    const selected = normalizeDate(readDateFromRoot(root));
    if (selected) return monthKeyFromIso(selected);
    const allowed = availableDatesSet();
    if (allowed && allowed.size) {
      const sorted = [...allowed].sort();
      const { min } = dateBoundsFromRoot(root);
      const firstSelectable = sorted.find((iso) => !min || iso >= min);
      if (firstSelectable) return monthKeyFromIso(firstSelectable);
      return monthKeyFromIso(sorted[0]);
    }
    const { min } = dateBoundsFromRoot(root);
    if (min) return monthKeyFromIso(min);
    return monthKeyFromIso(pickupPolicy.earliestPickupDate());
  };

  const getViewMonth = (root) => {
    const cal = getCalendarEl(root);
    const { minMonth, maxMonth } = calendarMonthBounds(root);
    const fallback = defaultViewMonth(root);
    const stored = cal && cal.dataset.viewMonth;
    const candidate = stored || fallback;
    if (!minMonth && !maxMonth) return candidate;
    return clampMonthKey(candidate, minMonth, maxMonth);
  };

  const getCalendarEl = (root) => root && root.querySelector('[data-pitb-cal]');

  const setViewMonth = (root, monthKey) => {
    const cal = getCalendarEl(root);
    if (cal) cal.dataset.viewMonth = monthKey;
  };

  const bookingOptionIndexes = (product) => {
    const options = product.options || [];
    let dateIdx = -1;
    let slotIdx = -1;
    let dateNamed = false;
    let slotNamed = false;
    options.forEach((name, index) => {
      const label = String(name || '').toLowerCase();
      if (dateIdx < 0 && label.includes('date')) {
        dateIdx = index;
        dateNamed = true;
      }
      if (
        slotIdx < 0 &&
        (label.includes('time slot') ||
          label.includes('timeslot') ||
          label.includes('slot') ||
          label.includes('time'))
      ) {
        slotIdx = index;
        slotNamed = true;
      }
    });
    if (dateIdx < 0 && options.length >= 1) dateIdx = 0;
    if (slotIdx < 0 && options.length >= 2) slotIdx = 1;
    if (options.length >= 3 && dateIdx === 0 && slotIdx === 1 && !dateNamed && !slotNamed) {
      dateIdx = 1;
      slotIdx = 2;
    }
    return { dateIdx, slotIdx };
  };

  const parseVariantTitle = (title) => {
    const parts = String(title || '')
      .split('/')
      .map((part) => part.trim())
      .filter(Boolean);
    if (parts.length >= 3) {
      return { dateLabel: parts[parts.length - 2], slotRaw: parts[parts.length - 1] };
    }
    if (parts.length === 2) {
      return { dateLabel: parts[0], slotRaw: parts[1] };
    }
    return { dateLabel: '', slotRaw: '' };
  };

  const variantOptionValues = (variant) => {
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options.map((value) => String(value || '').trim());
    }
    return [variant.option1, variant.option2, variant.option3]
      .map((value) => (value == null ? '' : String(value).trim()))
      .filter(Boolean);
  };

  const variantBookingFields = (variant, indexes) => {
    const opts = variantOptionValues(variant);
    let dateLabel = indexes.dateIdx >= 0 ? opts[indexes.dateIdx] || '' : '';
    let slotRaw = indexes.slotIdx >= 0 ? opts[indexes.slotIdx] || '' : '';
    const title = String(variant.title || variant.name || '').trim();
    if (title && title !== 'Default Title') {
      const parsed = parseVariantTitle(title);
      if (!dateLabel || dateLabel === 'Default Title') dateLabel = parsed.dateLabel;
      if (!slotRaw || slotRaw === 'Default Title') slotRaw = parsed.slotRaw;
    }
    return { dateLabel, slotRaw };
  };

  const appendDayCell = (grid, root, { year, month, day, dateMin, dateMax, selected, locked }) => {
    const iso = isoFromParts(year, month, day);
    const allowed = availableDatesSet();
    const onItemDates = !allowed || allowed.has(iso);
    const inRange = onItemDates && isInEventRange(iso, dateMin, dateMax);
    const soldOut = inRange && isDateSoldOut(iso);
    const cell = document.createElement('button');
    cell.type = 'button';
    cell.className = 'pitb-cal__day';
    if (inRange && !soldOut) cell.dataset.pitbPickupDateDay = iso;
    cell.setAttribute('role', 'gridcell');

    const isSelected = inRange && !soldOut && selected === iso;

    if (!inRange) {
      cell.classList.add('is-outside-range');
      cell.disabled = true;
      cell.setAttribute('aria-disabled', 'true');
    } else if (soldOut) {
      cell.classList.add('is-sold-out');
      cell.disabled = true;
      cell.setAttribute('aria-disabled', 'true');
    } else {
      cell.classList.add('is-in-range');
      cell.disabled = locked;
    }

    if (isSelected) cell.classList.add('is-selected');
    cell.setAttribute(
      'aria-label',
      `${day} ${MONTH_NAMES[month - 1]} ${year}${!inRange ? ', unavailable' : soldOut ? ', sold out' : ''}`
    );
    cell.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    cell.textContent = String(day);

    const wrap = document.createElement('div');
    wrap.className = 'pitb-cal__cell';
    wrap.appendChild(cell);
    grid.appendChild(wrap);
  };

  // Civil weekday for Y-M-D in Asia/Singapore (Sun=0). Uses UTC parts so the
  // column never depends on the browser's local timezone.
  const civilWeekdaySun0 = (year, month, day) =>
    new Date(Date.UTC(year, month - 1, day)).getUTCDay();

  const renderMonthGrid = (grid, root, year, month, { dateMin, dateMax, selected, locked }) => {
    const startPad = civilWeekdaySun0(year, month, 1);
    const daysInMonth = new Date(Date.UTC(year, month, 0)).getUTCDate();

    // Non-empty text avoids Dawn `div:empty { display: none }`, which was
    // collapsing pads so e.g. 14 Oct (Wed) appeared under Saturday.
    const appendEmptyCell = () => {
      const empty = document.createElement('div');
      empty.className = 'pitb-cal__cell pitb-cal__cell--empty';
      empty.setAttribute('aria-hidden', 'true');
      empty.textContent = '\u00a0';
      grid.appendChild(empty);
    };

    for (let i = 0; i < startPad; i += 1) appendEmptyCell();

    for (let day = 1; day <= daysInMonth; day += 1) {
      appendDayCell(grid, root, { year, month, day, dateMin, dateMax, selected, locked });
    }

    const totalCells = startPad + daysInMonth;
    const trailingPad = totalCells % 7 === 0 ? 0 : 7 - (totalCells % 7);
    for (let i = 0; i < trailingPad; i += 1) appendEmptyCell();
  };

  const renderCalendar = (root) => {
    const cal = getCalendarEl(root);
    if (!cal) return;

    const grid = cal.querySelector('[data-pitb-cal-grid]');
    const title = cal.querySelector('[data-pitb-cal-title]');
    const prevBtn = cal.querySelector('[data-pitb-cal-nav="prev"]');
    const nextBtn = cal.querySelector('[data-pitb-cal-nav="next"]');
    if (!grid) return;

    const selected = normalizeDate(readDateFromRoot(root));
    const { min: dateMin, max: dateMax } = dateBoundsFromRoot(root);
    const { minMonth, maxMonth } = calendarMonthBounds(root);
    const viewMonth = getViewMonth(root);
    setViewMonth(root, viewMonth);

    const locked = isBookingProcessing() || isCloseState();
    const [year, month] = viewMonth.split('-').map(Number);
    if (!Number.isFinite(year) || !Number.isFinite(month)) {
      const fallback = defaultViewMonth(root);
      setViewMonth(root, fallback);
      renderCalendar(root);
      return;
    }

    if (title) title.textContent = `${MONTH_NAMES[month - 1]} ${year}`;
    if (prevBtn) {
      const hidePrev = !minMonth || viewMonth <= minMonth;
      prevBtn.disabled = hidePrev;
      prevBtn.hidden = false;
      prevBtn.setAttribute('aria-hidden', hidePrev ? 'true' : 'false');
    }
    if (nextBtn) {
      const hideNext = !maxMonth || viewMonth >= maxMonth;
      nextBtn.disabled = hideNext;
      nextBtn.hidden = false;
      nextBtn.setAttribute('aria-hidden', hideNext ? 'true' : 'false');
    }

    grid.innerHTML = '';
    renderMonthGrid(grid, root, year, month, { dateMin, dateMax, selected, locked });
  };

  const renderAllCalendars = () => {
    allRoots().forEach(renderCalendar);
  };

  const formatDateDisplay = (iso) => {
    if (!iso) return '';
    const label = LABEL_BY_ISO[iso];
    if (label) return label;
    const [year, month, day] = iso.split('-').map(Number);
    if (!year || !month || !day) return iso;
    return `${day} ${MONTH_NAMES[month - 1]} ${year}`;
  };

  const updateDateTrigger = (root) => {
    const trigger = root.querySelector('[data-pitb-date-trigger]');
    const labelEl = root.querySelector('[data-pitb-date-trigger-label]');
    if (!trigger || !labelEl) return;
    const date = normalizeDate(readDateFromRoot(root));
    labelEl.textContent = date ? formatDateDisplay(date) : 'Choose a date';
    trigger.classList.toggle('has-value', Boolean(date));
  };

  const updateCartSummaryDetail = (date, slot) => {
    const el = document.querySelector('[data-pitb-entry-detail]');
    if (!el) return;
    if (date && slot) {
      el.textContent = `(${formatDateDisplay(date)}, ${String(slot).replace(/[–—]/g, '-')})`;
    } else {
      el.textContent = '';
    }
  };

  const updateAllDateTriggers = () => {
    allRoots().forEach(updateDateTrigger);
  };

  const closeDatePopup = (root) => {
    if (!root) return;
    const popup = root.querySelector('[data-pitb-date-popup]');
    const trigger = root.querySelector('[data-pitb-date-trigger]');
    if (!popup) return;
    popup.hidden = true;
    popup.classList.remove('is-open');
    document.documentElement.classList.remove('pitb-date-popup-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
  };

  const closeAllDatePopups = () => {
    allRoots().forEach(closeDatePopup);
  };

  const syncClosedBookingUi = (root, closed) => {
    if (!root) return;
    const dateWrap = root.querySelector('[data-pitb-date-wrap]');
    const pickerRow = root.querySelector('.pitb-booking__picker-row');
    const timeslotWrap = root.querySelector('[data-pitb-timeslot-wrap]');
    if (dateWrap) dateWrap.hidden = closed;
    if (pickerRow) pickerRow.hidden = closed;
    if (timeslotWrap && !root.classList.contains('pitb-booking--inline')) {
      timeslotWrap.hidden = closed;
    }
    if (closed) closeDatePopup(root);
  };

  const openDatePopup = (root) => {
    const popup = root.querySelector('[data-pitb-date-popup]');
    const trigger = root.querySelector('[data-pitb-date-trigger]');
    const dialog = root.querySelector('.pitb-booking__date-dialog');
    if (!popup || isCloseState() || isBookingProcessing()) return;
    closeAllDatePopups();
    setViewMonth(root, defaultViewMonth(root));
    popup.hidden = false;
    popup.classList.add('is-open');
    document.documentElement.classList.add('pitb-date-popup-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    renderCalendar(root);
    if (dialog) dialog.focus();
  };

  const ticketKey = (date, slot) => {
    const iso = normalizeDate(date);
    const key = normalizeSlot(slot);
    if (!iso || !key) return '';
    return `${iso}|${key}`;
  };

  const applyCapacityUi = (root) => {
    if (!root || isBookingProcessing()) return;
    const closed = isCloseState();
    let date = normalizeDate(readDateFromRoot(root));
    if (date && isDateSoldOut(date)) {
      date = '';
      const hidden = root.querySelector('[data-pitb-pickup-date]');
      if (hidden) hidden.value = '';
      root.dataset.pitbDate = '';
      root.dataset.pitbSlot = '';
      root.querySelectorAll('[data-pitb-timeslot]').forEach((input) => {
        input.checked = false;
      });
      updateDateTrigger(root);
      const timeslotWrap = root.querySelector('[data-pitb-timeslot-wrap]');
      if (timeslotWrap && !root.classList.contains('pitb-booking--inline')) {
        timeslotWrap.classList.add('is-hidden');
      }
    }
    root.classList.toggle('is-closed', closed);
    syncClosedBookingUi(root, closed);
    if (closed) {
      root.dataset.pitbSlot = '';
      root.dataset.pitbDate = '';
    }

    const slotList = root.querySelector('[data-pitb-slot-list]');
    if (slotList) slotList.classList.remove('is-pending-date');

    root.querySelectorAll('[data-pitb-slot-option]').forEach((labelEl) => {
      const key = normalizeSlot(labelEl.getAttribute('data-pitb-slot-option'));
      const input = labelEl.querySelector('[data-pitb-timeslot]');
      const text = labelEl.querySelector('[data-pitb-slot-label]');
      if (!input || !key) return;
      const remaining = date ? remainingForSlot(date, key) : 0;
      const isFull = remaining <= 0;
      const disable = closed || !date || isFull;
      input.disabled = disable;
      if (closed || !date || (disable && input.checked)) input.checked = false;
      labelEl.classList.toggle('is-full', isFull || closed || !date);
      labelEl.setAttribute('aria-disabled', disable ? 'true' : 'false');
      if (text) text.textContent = key;
    });
  };

  const HINTS = {
    merch: 'Add a preorder item to checkout.',
    fee: '',
    feeAdding: '',
    date: '',
    stale: 'That pickup date is no longer available. Pickup dates move later for orders placed from 8 PM SGT. Choose a new date and timeslot.',
    timeslot: 'Choose a pickup timeslot for your selected date.',
    full: 'That timeslot is fully booked. Choose another available slot.',
    entry: 'Choose your visit date and timeslot to reserve entry.',
    login: 'Log in or create an account to check out.',
    soldout: 'Remove sold-out items before checking out.',
    invite: 'Remove by-invite-only items before checking out.',
  };
  const PROCESSING_HINT = 'Saving your date and timeslot…';
  const ALL_HINTS = [...Object.keys(HINTS).map((key) => HINTS[key]), PROCESSING_HINT];

  const checkoutButtons = () =>
    Array.from(
      document.querySelectorAll('#checkout, #CartDrawer-Checkout, [data-pitb-checkout-gate], button[name="checkout"]')
    );

  const isCloseState = () =>
    Boolean(
      window.PITB_ORDER_CAP &&
        (window.PITB_ORDER_CAP.closeState || window.PITB_ORDER_CAP.fullyBooked)
    );

  const cartLooksEmpty = () => {
    const footer = document.getElementById('main-cart-footer');
    const drawer = document.querySelector('cart-drawer');
    if (footer && footer.classList.contains('is-empty')) return true;
    if (drawer && drawer.classList.contains('is-empty')) return true;
    return false;
  };

  const feeUpdating = () =>
    isBookingProcessing() ||
    Boolean(document.querySelector('#main-cart-footer.is-updating, .cart-drawer__footer.is-updating'));

  const ticketVariantIds = () => {
    const byKey =
      (catalogRoot.event && catalogRoot.event.ticketSpotByKey) || cfg.ticketSpotByKey || {};
    const bySlot = cfg.ticketSpotBySlot || {};
    return [...Object.values(byKey), ...Object.values(bySlot)].map(String);
  };

  const isFeeItem = (item) => {
    if (!item) return false;
    const handle = item.handle || item.product_handle || '';
    const title = String(item.product_title || item.title || '');
    const sku = String(item.sku || '');
    const variantId = String(item.variant_id || '');
    const ticketVariants = ticketVariantIds();
    const selfCollectVariants = selfCollectVariantIds();
    if (SELF_COLLECT_HANDLE && handle === SELF_COLLECT_HANDLE) return false;
    if (selfCollectVariants.includes(variantId)) return false;
    return (
      handle === FEE_HANDLE ||
      handle === TICKET_HANDLE ||
      handle === LEGACY_FEE_HANDLE ||
      ticketVariants.includes(variantId) ||
      handle.includes('entry-fee') ||
      sku.indexOf('TS-') === 0 ||
      (item.properties && item.properties._pitb_entry_fee === 'required') ||
      /entry fee/i.test(title) ||
      /entry pass/i.test(title)
    );
  };

  let lastCart = null;
  let lastCommittedAttrs = { pitb_pickup_date: '', pitb_timeslot: '' };
  let bookingProcessingDepth = 0;

  const isBookingProcessing = () => bookingProcessingDepth > 0;

  const setBookingProcessing = (on) => {
    if (on) bookingProcessingDepth += 1;
    else bookingProcessingDepth = Math.max(0, bookingProcessingDepth - 1);

    const busy = bookingProcessingDepth > 0;
    allRoots().forEach((root) => {
      root.classList.toggle('is-processing', busy);
      root.setAttribute('aria-busy', busy ? 'true' : 'false');

      const cal = getCalendarEl(root);
      const trigger = root.querySelector('[data-pitb-date-trigger]');
      if (trigger) trigger.disabled = busy || isCloseState();
      if (cal) {
        cal.querySelectorAll('[data-pitb-pickup-date-day]').forEach((el) => {
          el.disabled = busy || isCloseState();
        });
      }
      if (busy) closeDatePopup(root);

      root.querySelectorAll('[data-pitb-timeslot]').forEach((input) => {
        if (busy) input.disabled = true;
      });

      root.querySelectorAll('[data-pitb-slot-option]').forEach((labelEl) => {
        labelEl.classList.toggle('is-locked', busy);
        if (busy) labelEl.setAttribute('aria-disabled', 'true');
      });
    });

    statusEls().forEach((status) => {
      if (!status) return;
      if (busy) {
        status.hidden = false;
        status.textContent = PROCESSING_HINT;
        return;
      }
      if ((status.textContent || '').trim() === PROCESSING_HINT) {
        status.textContent = '';
        status.hidden = true;
      }
    });

    if (!busy) {
      allRoots().forEach((root) => {
        root.querySelectorAll('[data-pitb-slot-option]').forEach((labelEl) => {
          labelEl.classList.remove('is-locked');
        });
      });
      allRoots().forEach(applyCapacityUi);
      syncCheckoutGate();
    }
  };

  const cartComposition = () => {
    if (lastCart && Array.isArray(lastCart.items) && lastCart.items.length) {
      return {
        hasFee: lastCart.items.some(isFeeItem),
        hasMerch: lastCart.items.some((item) => !isBookingLine(item)),
      };
    }

    const hasFee = Boolean(document.querySelector('[data-pitb-entry-fee-line]'));
    const hasMerch = Array.from(document.querySelectorAll('.cart-item')).some((row) => {
      if (row.hasAttribute('data-pitb-entry-fee-line')) return false;
      if (row.classList.contains('cart-item--pitb-entry-fee')) return false;
      const name = ((row.querySelector('.cart-item__name') || {}).textContent || '').trim();
      return !/entry fee/i.test(name) && !/entry pass/i.test(name);
    });

    return { hasFee, hasMerch };
  };

  const parseClock12 = (part) => {
    const m = String(part || '')
      .trim()
      .match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
    if (!m) return '';
    let hour = Number(m[1]);
    const minute = m[2];
    const ap = (m[3] || '').toUpperCase();
    if (ap === 'AM') {
      if (hour === 12) hour = 0;
    } else if (ap === 'PM' && hour !== 12) {
      hour += 12;
    }
    return `${String(hour).padStart(2, '0')}:${minute}`;
  };

  const toSlotKey = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    const parts = s.split(/\s*[–-]\s*/).map((part) => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const start = parseClock12(parts[0]);
      const end = parseClock12(parts[parts.length - 1]);
      if (start && end) return `${start}–${end}`;
    }
    return s.replace(/-/g, '–').replace(/\s+/g, ' ');
  };

  const slotFromTicketTitle = (title) => {
    const parsed = parseVariantTitle(title);
    if (parsed.slotRaw) return toSlotKey(parsed.slotRaw);
    return toSlotKey(title);
  };

  const dateFromTicketTitle = (title) => {
    const parsed = parseVariantTitle(title);
    if (parsed.dateLabel) return normalizeDate(parsed.dateLabel);
    return '';
  };

  const slotFromTicketVariant = (variantId) => {
    const map = activeCatalog().ticketSpotByKey || cfg.ticketSpotByKey || {};
    const id = String(variantId || '');
    const hit = Object.keys(map).find((key) => String(map[key]) === id);
    if (!hit) return '';
    return normalizeSlot(hit.split('|')[1] || '');
  };

  const dateFromTicketVariant = (variantId) => {
    const map = activeCatalog().ticketSpotByKey || cfg.ticketSpotByKey || {};
    const id = String(variantId || '');
    const hit = Object.keys(map).find((key) => String(map[key]) === id);
    if (!hit) return '';
    return normalizeDate(hit.split('|')[0] || '');
  };

  const ingestBookingVariant = (
    variant,
    indexes,
    { map, spotMap, dateSet, slotSet, isoByLabel, labelByIso, prior, mode }
  ) => {
    let { dateLabel, slotRaw } = variantBookingFields(variant, indexes);
    let iso = normalizeDate(dateLabel);
    let slot = toSlotKey(slotRaw) || slotFromTicketTitle(slotRaw) || normalizeSlot(slotRaw);
    if ((!iso || !slot) && variant.title) {
      const parsed = parseVariantTitle(variant.title);
      iso = iso || normalizeDate(parsed.dateLabel) || dateFromTicketTitle(variant.title);
      slot = slot || toSlotKey(parsed.slotRaw) || slotFromTicketTitle(variant.title);
      if (!dateLabel || dateLabel === 'Default Title') dateLabel = parsed.dateLabel;
    }
    if (!isIsoDate(iso) || !slot) return;
    dateSet.add(iso);
    slotSet.add(slot);
    if (dateLabel) {
      isoByLabel[dateLabel] = iso;
      labelByIso[iso] = dateLabel;
    }
    const key = ticketKey(iso, slot);
    const qty = Number(variant.inventory_quantity);
    const tracksInventory =
      variant.inventory_management === 'shopify' ||
      (variant.inventory_management != null && variant.inventory_management !== '');
    const priorLeft = Number(prior.ticketRemaining && prior.ticketRemaining[key]);
    let left = 0;
    if (!variant.available) {
      left = 0;
    } else if (tracksInventory) {
      if (Number.isFinite(qty) && qty > 0) {
        left = qty;
      } else if (Number.isFinite(priorLeft) && priorLeft > 0) {
        left = priorLeft;
      } else {
        left = 1;
      }
    } else if (Number.isFinite(qty) && qty > 0) {
      left = qty;
    } else {
      left = Math.max(Number.isFinite(priorLeft) ? priorLeft : 0, 99);
    }
    map[key] = left;
    const variantId = variant.id || variant.variant_id;
    if (variantId && mode === 'event' && window.PITB_ENTRY_FEE) {
      window.PITB_ENTRY_FEE.ticketSpotByKey = window.PITB_ENTRY_FEE.ticketSpotByKey || {};
      window.PITB_ENTRY_FEE.ticketSpotByKey[key] = variantId;
    }
    if (variantId) spotMap[key] = variantId;
  };

  const fetchCatalogDatesFromSection = async (handle) => {
    if (!handle) return null;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const url = `${root}products/${handle}?section_id=pitb-booking-catalog-dates`;
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) return null;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const script = doc.querySelector('[data-pitb-booking-catalog-dates]');
      if (!script || !script.textContent) return null;
      return JSON.parse(script.textContent);
    } catch (_) {
      return null;
    }
  };

  const mergeSectionDatesIntoCatalog = (payload, { dateSet, labelByIso, isoByLabel }) => {
    if (!payload) return;
    (payload.dates || []).forEach((entry) => {
      const iso = normalizeDate(entry);
      if (isIsoDate(iso)) dateSet.add(iso);
    });
    const labels = payload.dateLabelByIso || {};
    Object.keys(labels).forEach((iso) => {
      const normalized = normalizeDate(iso);
      const label = labels[iso];
      if (!isIsoDate(normalized) || !label) return;
      labelByIso[normalized] = label;
      isoByLabel[label] = normalized;
      dateSet.add(normalized);
    });
  };

  const fetchExtraBookingVariants = async (handle, variantCount, firstPageCount) => {
    const totalPages =
      variantCount > 250
        ? Math.ceil(variantCount / 250)
        : firstPageCount >= 250
          ? 2
          : 1;
    if (totalPages <= 1) return [];

    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const extra = [];
    for (let page = 2; page <= totalPages; page += 1) {
      const url = `${root}products/${handle}?section_id=pitb-booking-variants&page=${page}`;
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) continue;
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const script = doc.querySelector('[data-pitb-booking-variants]');
      if (!script || !script.textContent) continue;
      try {
        const payload = JSON.parse(script.textContent);
        if (Array.isArray(payload.variants) && payload.variants.length) {
          extra.push(...payload.variants);
        }
        if (payload.pages && page >= payload.pages) break;
      } catch (_) {
        /* malformed section response */
      }
    }
    return extra;
  };

  const refreshTicketRemaining = async (mode = activeMode) => {
    try {
      let product = null;
      let handle = '';
      for (const candidate of catalogHandlesToTry(mode)) {
        const res = await fetch(`/products/${candidate}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!res.ok) continue;
        product = await res.json();
        handle = product.handle || candidate;
        break;
      }
      if (!product || !handle) return;
      const indexes = bookingOptionIndexes(product);
      const prior = catalogRoot[mode] || {};
      const map = { ...(prior.ticketRemaining || window.PITB_TICKET_REMAINING || {}) };
      const spotMap = { ...(prior.ticketSpotByKey || {}) };
      const dateSet = new Set();
      const slotSet = new Set();
      const isoByLabel = { ...(prior.isoByDateLabel || {}) };
      const labelByIso = { ...(prior.dateLabelByIso || {}) };
      mergeCatalogDates(dateSet, prior);

      const sectionDates = await fetchCatalogDatesFromSection(handle);
      mergeSectionDatesIntoCatalog(sectionDates, { dateSet, labelByIso, isoByLabel });

      const variantCount = Number(prior.variantCount) || product.variants.length;
      const allVariants = [...(product.variants || [])];
      const extraVariants = await fetchExtraBookingVariants(
        handle,
        variantCount,
        allVariants.length
      );
      if (extraVariants.length) allVariants.push(...extraVariants);

      const ingestCtx = { map, spotMap, dateSet, slotSet, isoByLabel, labelByIso, prior, mode };
      allVariants.forEach((variant) => ingestBookingVariant(variant, indexes, ingestCtx));
      bookingRootDataset(mode).dates.forEach((iso) => dateSet.add(iso));
      if (!dateSet.size && !slotSet.size) return;
      if (!catalogRoot[mode]) catalogRoot[mode] = {};
      catalogRoot[mode].handle = product.handle || handle;
      catalogRoot[mode].ticketSpotByKey = spotMap;
      catalogRoot[mode].ticketRemaining = { ...map };
      catalogRoot[mode].availableDates = [...dateSet].sort();
      catalogRoot[mode].slots = [...slotSet].sort();
      catalogRoot[mode].isoByDateLabel = isoByLabel;
      catalogRoot[mode].dateLabelByIso = labelByIso;
      catalogRoot[mode].variantCount = variantCount;
      if (dateSet.size) {
        catalogRoot[mode].availableDates = [...dateSet].sort();
        const boundIsos = [...dateSet];
        Object.keys(labelByIso).forEach((iso) => {
          const normalized = normalizeDate(iso);
          if (isIsoDate(normalized)) boundIsos.push(normalized);
        });
        if (prior.dateMin) boundIsos.push(normalizeDate(prior.dateMin));
        if (prior.dateMax) boundIsos.push(normalizeDate(prior.dateMax));
        if (sectionDates && sectionDates.dateMin) boundIsos.push(normalizeDate(sectionDates.dateMin));
        if (sectionDates && sectionDates.dateMax) boundIsos.push(normalizeDate(sectionDates.dateMax));
        boundIsos.sort();
        catalogRoot[mode].dateMin = boundIsos[0];
        catalogRoot[mode].dateMax = boundIsos[boundIsos.length - 1];
      } else if (sectionDates && (sectionDates.dateMin || sectionDates.dateMax)) {
        catalogRoot[mode].dateMin = sectionDates.dateMin || prior.dateMin || '';
        catalogRoot[mode].dateMax = sectionDates.dateMax || prior.dateMax || '';
      }
      window.PITB_TICKET_REMAINING = map;
      if (mode === activeMode) {
        applyCatalogMode(mode);
        const selectedSlot = normalizeSlot((current() || {}).pitb_timeslot);
        syncSlotLists(catalogRoot[mode].slots || [], selectedSlot, 'pitb-slot');
        renderAllCalendars();
        allRoots().forEach(applyCapacityUi);
        syncCheckoutGate();
      }
    } catch (_) {
      /* password / network — Liquid map stays */
    }
  };

  const prefetchCatalogDates = async (mode = activeMode) => {
    const handle = catalogHandleForMode(mode);
    const payload = await fetchCatalogDatesFromSection(handle);
    if (!payload) return;
    if (!catalogRoot[mode]) catalogRoot[mode] = {};
    const cat = catalogRoot[mode];
    const dateSet = new Set(Array.isArray(cat.availableDates) ? cat.availableDates : []);
    const labelByIso = { ...(cat.dateLabelByIso || {}) };
    const isoByLabel = { ...(cat.isoByDateLabel || {}) };
    mergeSectionDatesIntoCatalog(payload, { dateSet, labelByIso, isoByLabel });
    bookingRootDataset(mode).dates.forEach((iso) => dateSet.add(iso));
    if (dateSet.size) cat.availableDates = [...dateSet].sort();
    cat.dateLabelByIso = labelByIso;
    cat.isoByDateLabel = isoByLabel;
    const boundIsos = [...dateSet];
    if (cat.dateMin) boundIsos.push(normalizeDate(cat.dateMin));
    if (cat.dateMax) boundIsos.push(normalizeDate(cat.dateMax));
    if (payload.dateMin) boundIsos.push(normalizeDate(payload.dateMin));
    if (payload.dateMax) boundIsos.push(normalizeDate(payload.dateMax));
    boundIsos.sort();
    if (boundIsos.length) {
      cat.dateMin = boundIsos[0];
      cat.dateMax = boundIsos[boundIsos.length - 1];
    } else {
      if (payload.dateMin) cat.dateMin = payload.dateMin;
      if (payload.dateMax) cat.dateMax = payload.dateMax;
    }
    if (mode === activeMode) {
      applyCatalogMode(mode);
      renderAllCalendars();
    }
  };

  const catalogKeyForSlot = (date, slot) => {
    const iso = normalizeDate(date);
    const slotNorm = toSlotKey(slot) || normalizeSlot(slot);
    if (!iso || !slotNorm) return '';
    const direct = ticketKey(iso, slotNorm);
    const cat = activeCatalog();
    const map = cat.ticketSpotByKey || {};
    if (Object.prototype.hasOwnProperty.call(map, direct)) return direct;
    const keys = Object.keys(map);
    const hit = keys.find((key) => {
      const parts = String(key).split('|');
      const keyIso = normalizeDate(parts[0] || '');
      const keySlot = toSlotKey(parts[1] || '') || normalizeSlot(parts[1] || '');
      return keyIso === iso && keySlot === slotNorm;
    });
    return hit || direct;
  };

  const remainingForSlot = (date, slot) => {
    const key = catalogKeyForSlot(date, slot);
    if (!key) return 0;
    const map = window.PITB_TICKET_REMAINING || activeCatalog().ticketRemaining || {};
    if (Object.prototype.hasOwnProperty.call(map, key)) {
      const ticketLeft = Number(map[key]);
      return Number.isFinite(ticketLeft) ? Math.max(ticketLeft, 0) : 0;
    }
    const knownKeys = Object.keys(activeCatalog().ticketSpotByKey || {});
    if (knownKeys.length) return 1;
    return 1;
  };

  const isSelfCollect = () => {
    const page = document.querySelector('[data-pitb-cart-page]');
    if (page && page.getAttribute('data-pitb-collection') === 'self_collect') return true;
    const attrs = (lastCart && lastCart.attributes) || {};
    return String(attrs.pitb_collection_method || '') === 'self_collect';
  };

  const checkoutReadiness = () => {
    if (window.PITBQuantityLimit && window.PITBQuantityLimit.errorsForCart(lastCart).length) {
      return { ok: false, reason: 'quantity', hint: '' };
    }
    const blocked = isCloseState();
    if (blocked) return { ok: false, reason: 'blocked', hint: '' };

    if (window.PITBCheckoutAuth && !window.PITBCheckoutAuth.canProceedToCheckout()) {
      return { ok: false, reason: 'login', hint: HINTS.login };
    }

    const empty = cartLooksEmpty();
    const { hasFee, hasMerch } = cartComposition();
    if (empty || !hasMerch) return { ok: false, reason: 'merch', hint: HINTS.merch };

    const lineBlock =
      document.querySelector('[data-pitb-line-blocked]')?.getAttribute('data-pitb-line-blocked') ||
      document.querySelector('[data-pitb-checkout-block]')?.getAttribute('data-pitb-checkout-block') ||
      '';
    if (lineBlock === 'invite') return { ok: false, reason: 'invite', hint: HINTS.invite };
    if (lineBlock === 'soldout') return { ok: false, reason: 'soldout', hint: HINTS.soldout };
    if (lineBlock) return { ok: false, reason: lineBlock, hint: HINTS.soldout };

    if (isSelfCollect()) {
      const attrs = current();
      const date = normalizeDate(attrs.pitb_pickup_date);
      const slot = normalizeSlot(attrs.pitb_timeslot);
      if (!date) return { ok: false, reason: 'date', hint: HINTS.date };
      if (pickupDateIsStale(date)) return { ok: false, reason: 'date', hint: HINTS.stale };
      if (!slot) return { ok: false, reason: 'timeslot', hint: HINTS.timeslot };
      if (remainingForSlot(date, slot) <= 0) return { ok: false, reason: 'full', hint: HINTS.full };
      const hasTicket =
        (lastCart && (lastCart.items || []).some(isSelfCollectItem)) ||
        Boolean(document.querySelector('[data-pitb-self-collect-line]'));
      if (feeUpdating()) return { ok: false, reason: 'fee', hint: HINTS.feeAdding };
      if (!hasTicket) return { ok: false, reason: 'fee', hint: HINTS.entry };
      return { ok: true, reason: '', hint: '' };
    }

    if (feeUpdating()) return { ok: false, reason: 'fee', hint: HINTS.feeAdding };
    if (!hasFee) return { ok: false, reason: 'fee', hint: HINTS.fee };

    const attrs = current();
    const date = normalizeDate(attrs.pitb_pickup_date);
    const slot = normalizeSlot(attrs.pitb_timeslot);
    if (!date) return { ok: false, reason: 'date', hint: HINTS.date };
    if (pickupDateIsStale(date)) return { ok: false, reason: 'date', hint: HINTS.stale };
    if (!slot) return { ok: false, reason: 'timeslot', hint: HINTS.timeslot };
    if (remainingForSlot(date, slot) <= 0) return { ok: false, reason: 'full', hint: HINTS.full };

    return { ok: true, reason: '', hint: '' };
  };

  const entryReserveButtons = () =>
    Array.from(document.querySelectorAll('[data-pitb-entry-reserve]'));

  const syncEntryReserve = () => {
    const blocked = isCloseState();
    const attrs = current();
    const date = normalizeDate(attrs.pitb_pickup_date);
    const slot = normalizeSlot(attrs.pitb_timeslot);
    const full = Boolean(date && slot) && remainingForSlot(date, slot) <= 0;
    const disable = blocked || !date || !slot || full;
    let hint = '';
    if (blocked) hint = '';
    else if (!date) hint = HINTS.date;
    else if (!slot) hint = HINTS.timeslot;
    else if (full) hint = HINTS.full;

    entryReserveButtons().forEach((el) => {
      el.disabled = disable;
      el.setAttribute('aria-disabled', disable ? 'true' : 'false');
      el.classList.toggle('pitb-pill--disabled', disable && el.classList.contains('pitb-pill'));
      if (hint) el.setAttribute('title', hint);
      else el.removeAttribute('title');
    });
  };

  const syncCheckoutGate = () => {
    if (window.PITBQuantityLimit) {
      window.PITBQuantityLimit.syncControls(lastCart);
    }
    const ready = checkoutReadiness();
    const disable = !ready.ok;
    const feeBusy = feeUpdating();
    const navigating =
      window.PITBCheckoutAuth &&
      typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
      window.PITBCheckoutAuth.isNavigating();

    checkoutButtons().forEach((btn) => {
      if (btn.classList.contains('loading') || feeBusy || navigating) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      btn.disabled = disable;
      btn.setAttribute('aria-disabled', disable ? 'true' : 'false');
      if (ready.hint) btn.setAttribute('title', ready.hint);
      else btn.removeAttribute('title');
    });

    statusEls().forEach((status) => {
      if (!status) return;
      if (isCloseState()) {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      if (status.closest('#pitb-tickets')) {
        const attrs = current();
        const date = normalizeDate(attrs.pitb_pickup_date);
        const slot = normalizeSlot(attrs.pitb_timeslot);
        if (!date) {
          status.hidden = true;
          status.textContent = '';
        } else if (!slot) {
          status.hidden = false;
          status.textContent = HINTS.entry;
        } else if (remainingForSlot(date, slot) <= 0) {
          status.hidden = false;
          status.textContent = HINTS.full;
        } else {
          status.hidden = true;
          status.textContent = '';
        }
        return;
      }
      const currentText = (status.textContent || '').trim();
      const isHint = currentText === '' || ALL_HINTS.indexOf(currentText) !== -1;
      if (ready.hint && isHint) {
        status.hidden = false;
        status.textContent = ready.hint;
      } else if (!ready.hint && isHint) {
        status.hidden = true;
        status.textContent = '';
      }
    });

    syncEntryReserve();
    if (window.PITBEntryFee && typeof window.PITBEntryFee.syncSlotForms === 'function') {
      window.PITBEntryFee.syncSlotForms();
    }
  };

  const refreshCapacity = () => {
    allRoots().forEach(applyCapacityUi);
    renderAllCalendars();
    syncCheckoutGate();
  };

  const refreshCapacityFromTickets = () =>
    refreshTicketRemaining().then(() => {
      renderAllCalendars();
      refreshCapacity();
    });

  const readDateFromRoot = (root) => {
    if (!root) return '';
    const hidden = root.querySelector('[data-pitb-pickup-date]');
    return normalizeDate((hidden && hidden.value) || root.dataset.pitbDate || '');
  };

  const readFromRoot = (root) => {
    if (!root || isCloseState()) {
      return {
        pitb_timeslot: '',
        pitb_bring_friend: 'no',
        pitb_attendees: '1',
        pitb_pickup_date: '',
      };
    }
    const slot = root.querySelector('[data-pitb-timeslot]:checked');
    return {
      pitb_timeslot: slot ? normalizeSlot(slot.value) : '',
      pitb_bring_friend: 'no',
      pitb_attendees: '1',
      pitb_pickup_date: readDateFromRoot(root) || '',
    };
  };

  const preferredRoot = (hintRoot) => {
    if (hintRoot && hintRoot.matches && hintRoot.matches('[data-pitb-booking]')) return hintRoot;
    const roots = allRoots();
    if (!roots.length) return null;

    const visible = roots.find((root) => {
      const style = window.getComputedStyle(root);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = root.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
    return visible || roots[roots.length - 1] || roots[0];
  };

  const current = (hintRoot) => readFromRoot(preferredRoot(hintRoot));

  const attrsFromCart = (cart) => {
    const attributes = (cart && cart.attributes) || {};
    const items = (cart && cart.items) || [];
    let slot = normalizeSlot(attributes.pitb_timeslot || attributes['Pickup timeslot'] || '');
    let pickupDate = normalizeDate(attributes.pitb_pickup_date || attributes['Pickup date'] || '');

    if (!slot || !pickupDate) {
      for (const item of items) {
        const props = item.properties || {};
        if (props['Pickup timeslot']) slot = normalizeSlot(props['Pickup timeslot']);
        if (props['Pickup date']) pickupDate = normalizeDate(props['Pickup date']);
        if (slot && pickupDate) break;
      }
    }

    if (!slot || !pickupDate) {
      for (const item of items) {
        if (!isFeeItem(item)) continue;
        const fromMapDate = dateFromTicketVariant(item.variant_id);
        const fromMapSlot = slotFromTicketVariant(item.variant_id);
        const fromTitleDate = dateFromTicketTitle(item.variant_title || item.title);
        const fromTitleSlot = slotFromTicketTitle(item.variant_title || item.title);
        pickupDate = pickupDate || fromMapDate || fromTitleDate;
        slot = slot || fromMapSlot || fromTitleSlot;
        if (slot && pickupDate) break;
      }
    }

    return {
      pitb_timeslot: slot,
      pitb_bring_friend: 'no',
      pitb_attendees: '1',
      pitb_pickup_date: pickupDate || '',
    };
  };

  const applyAttrsToUi = (attrs) => {
    const closed = isCloseState();
    const root = preferredRoot();
    let date = closed ? '' : normalizeDate(attrs.pitb_pickup_date);
    if (date && !isDateSelectable(date, root)) date = '';
    let slot = closed ? '' : normalizeSlot(attrs.pitb_timeslot);
    if (!date) slot = '';

    allRoots().forEach((root) => {
      root.dataset.pitbSlot = slot;
      root.dataset.pitbDate = date;
      root.classList.toggle('is-closed', closed);
      root.classList.toggle('has-visit-date', Boolean(date));
      syncClosedBookingUi(root, closed);

      const hidden = root.querySelector('[data-pitb-pickup-date]');
      if (hidden) hidden.value = date || '';
      updateDateTrigger(root);

      const timeslotWrap = root.querySelector('[data-pitb-timeslot-wrap]');
      if (timeslotWrap) {
        if (root.classList.contains('pitb-booking--inline')) {
          timeslotWrap.classList.remove('is-hidden');
        } else {
          timeslotWrap.classList.toggle('is-hidden', !date);
        }
      }

      const slotList = root.querySelector('[data-pitb-slot-list]');
      if (slotList) {
        slotList.setAttribute('aria-disabled', date ? 'false' : 'true');
      }

      root.querySelectorAll('[data-pitb-timeslot]').forEach((input) => {
        if (closed || !date) {
          input.checked = false;
          input.disabled = true;
          const labelEl = input.closest('[data-pitb-slot-option]');
          if (labelEl) {
            labelEl.classList.add('is-full');
            labelEl.setAttribute('aria-disabled', 'true');
          }
          return;
        }
        input.checked = normalizeSlot(input.value) === slot;
      });
    });

    updateCartSummaryDetail(date, slot);

    if (closed) refreshCapacity();
    else {
      allRoots().forEach(applyCapacityUi);
      renderAllCalendars();
      syncCheckoutGate();
    }
  };

  let clearedClosedSlot = false;
  const clearTimeslotIfClosed = async (cart) => {
    if (!isCloseState() || clearedClosedSlot) return;
    const attrs = (cart && cart.attributes) || {};
    const hasSlot = Boolean(
      normalizeSlot(attrs.pitb_timeslot) || normalizeSlot(attrs['Pickup timeslot'])
    );
    const hasDate = Boolean(normalizeDate(attrs.pitb_pickup_date || attrs['Pickup date']));
    clearedClosedSlot = true;
    if (!hasSlot && !hasDate) {
      applyAttrsToUi({ pitb_timeslot: '', pitb_pickup_date: '' });
      return;
    }
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: checkoutAttributes({
            pitb_timeslot: '',
            pitb_pickup_date: '',
          }),
        }),
      });
    } catch (_) {
      /* ignore */
    }
    applyAttrsToUi({ pitb_timeslot: '', pitb_pickup_date: '' });
  };

  let clearingStalePickup = false;
  const clearStalePickupIfNeeded = async (cart) => {
    const attrs = attrsFromCart(cart || {});
    const date = normalizeDate(attrs.pitb_pickup_date);
    if (!date || !pickupDateIsStale(date)) return false;

    applyAttrsToUi({ pitb_timeslot: '', pitb_pickup_date: '' });
    lastCommittedAttrs = { pitb_pickup_date: '', pitb_timeslot: '' };
    statusEls().forEach((status) => {
      if (status) status.textContent = HINTS.stale;
    });
    syncCheckoutGate();

    if (clearingStalePickup) return true;
    clearingStalePickup = true;

    if (window.PITBEntryFee && typeof window.PITBEntryFee.setCartPageSyncing === 'function') {
      window.PITBEntryFee.setCartPageSyncing(true);
    }
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: checkoutAttributes({
            pitb_timeslot: '',
            pitb_pickup_date: '',
          }),
        }),
      });
      if (window.PITBEntryFee && typeof window.PITBEntryFee.sync === 'function') {
        await window.PITBEntryFee.sync({ addIfMissing: false, showLoading: false });
      }
      lastCart = await fetchCart();
    } catch (_) {
      /* keep UI cleared even if cart write fails */
    } finally {
      clearingStalePickup = false;
      if (window.PITBEntryFee && typeof window.PITBEntryFee.setCartPageSyncing === 'function') {
        window.PITBEntryFee.setCartPageSyncing(false);
      }
    }
    applyAttrsToUi({ pitb_timeslot: '', pitb_pickup_date: '' });
    syncCheckoutGate();
    return true;
  };

  const checkoutAttributes = (attrs) => {
    const iso = normalizeDate(attrs.pitb_pickup_date || '');
    const label = LABEL_BY_ISO[iso] || iso;
    const out = {
      pitb_pickup_date: iso,
      pitb_timeslot: attrs.pitb_timeslot || '',
      pitb_attendees: '1',
      pitb_bring_friend: 'no',
    };
    if (iso) out['Pickup date'] = label || iso;
    else out['Pickup date'] = '';
    if (attrs.pitb_timeslot) out['Pickup timeslot'] = attrs.pitb_timeslot;
    else out['Pickup timeslot'] = '';
    out['Entry passes'] = '1';
    out['Bring a friend'] = 'No';
    const accessCode =
      attrs.pitb_early_access ||
      (lastCart && lastCart.attributes && lastCart.attributes.pitb_early_access) ||
      '';
    if (accessCode) out.pitb_early_access = accessCode;
    const page = document.querySelector('[data-pitb-cart-page]');
    const collection =
      (page && page.getAttribute('data-pitb-collection')) ||
      attrs.pitb_collection_method ||
      (lastCart && lastCart.attributes && lastCart.attributes.pitb_collection_method) ||
      'event';
    out.pitb_collection_method = collection;
    out['Collection method'] = collection === 'self_collect' ? 'Self-collect Only' : 'Visit the Event';
    return out;
  };

  const LINE_PROP_HIDE = [
    'Pickup date',
    'Pickup timeslot',
    'Entry passes',
    'Bring a friend',
    'Fulfillment',
    'Event pickup',
  ];

  const sanitizeLineProperties = (existing = {}) => {
    const next = { ...existing };
    let changed = false;
    LINE_PROP_HIDE.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(next, key)) {
        delete next[key];
        changed = true;
      }
    });
    if (next._pitb_fulfillment !== 'pickup' && (existing.Fulfillment || existing['Event pickup'] || existing._pitb_fulfillment)) {
      next._pitb_fulfillment = 'pickup';
      changed = true;
    }
    return { props: next, changed };
  };

  const fetchCart = async () => {
    const cartRes = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!cartRes.ok) return null;
    lastCart = await cartRes.json();
    return lastCart;
  };

  const stripLineItemPickupProps = async (cart) => {
    const resolved = cart || (await fetchCart());
    if (!resolved) return;
    const items = resolved.items || [];
    const dirty = items.filter((item) => sanitizeLineProperties(item.properties || {}).changed);
    if (!dirty.length) return;

    await Promise.all(
      dirty.map((item) => {
        const { props } = sanitizeLineProperties(item.properties || {});
        return fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: item.quantity,
            properties: props,
          }),
        });
      })
    );
  };

  let saveQueue = Promise.resolve();

  const setCheckoutLoading = (on) => {
    if (window.PITBEntryFee && typeof window.PITBEntryFee.setCheckoutLoading === 'function') {
      window.PITBEntryFee.setCheckoutLoading(on);
      return;
    }
    const navigating =
      window.PITBCheckoutAuth &&
      typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
      window.PITBCheckoutAuth.isNavigating();
    const busy = Boolean(on) || navigating;
    checkoutButtons().forEach((btn) => {
      btn.classList.toggle('loading', busy);
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !busy);
      if (busy) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
      }
    });
    if (!busy) syncCheckoutGate();
  };

  const save = (hintRoot, { clearSlot = false } = {}) => {
    const run = async () => {
      setBookingProcessing(true);
      const attrs = current(hintRoot);
      if (clearSlot) attrs.pitb_timeslot = '';
      applyAttrsToUi(attrs);
      setCheckoutLoading(true);
      try {
        const res = await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: checkoutAttributes(attrs) }),
        });
        if (!res.ok) throw new Error('update failed');
        const cart = await res.json();
        lastCart = cart;
        lastCommittedAttrs = { ...attrs };

        await stripLineItemPickupProps(cart);

        // One fee sync only (was syncAttendees + ensure = 2× cart/ticket work).
        // Keep bookingProcessing true until this finishes so date/slot stay locked.
        if (window.PITBEntryFee && typeof window.PITBEntryFee.ensure === 'function') {
          const feeResult = await window.PITBEntryFee.ensure({
            cart,
            showLoading: false,
          });
          if (feeResult && feeResult.cart) lastCart = feeResult.cart;
        }
        if (window.PITBEntryFee && typeof window.PITBEntryFee.syncVisibleCartCount === 'function') {
          await window.PITBEntryFee.syncVisibleCartCount(lastCart);
        }

        applyAttrsToUi(attrs);
        return attrs;
      } catch (_) {
        statusEls().forEach((status) => {
          if (!status) return;
          status.hidden = false;
          status.textContent = 'Could not save booking details. Try again.';
        });
        applyAttrsToUi(lastCommittedAttrs);
        return null;
      } finally {
        setBookingProcessing(false);
        setCheckoutLoading(false);
        syncCheckoutGate();
      }
    };

    saveQueue = saveQueue.then(run, run);
    return saveQueue;
  };

  const restoreFromCart = async ({ persist = false } = {}) => {
    try {
      const cart = await fetchCart();
      if (!cart) return;
      lastCart = cart;
      if (isCloseState()) {
        await clearTimeslotIfClosed(cart);
        return;
      }
      if (await clearStalePickupIfNeeded(cart)) return;
      const attrs = attrsFromCart(cart);
      lastCommittedAttrs = { ...attrs };
      applyAttrsToUi(attrs);
      if (!persist) return;
      await stripLineItemPickupProps(cart);
      const existing = cart.attributes || {};
      const changed =
        (attrs.pitb_timeslot && existing.pitb_timeslot !== attrs.pitb_timeslot) ||
        (attrs.pitb_pickup_date && existing.pitb_pickup_date !== attrs.pitb_pickup_date);
      if (changed) {
        await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: checkoutAttributes(attrs) }),
        });
      }
    } catch (_) {
      /* ignore */
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;

    const closeBtn = target.closest('[data-pitb-date-close]');
    if (closeBtn) {
      const root = closeBtn.closest('[data-pitb-booking]');
      if (root) closeDatePopup(root);
      return;
    }

    const navBtn = target.closest('[data-pitb-cal-nav]');
    if (navBtn) {
      const root = navBtn.closest('[data-pitb-booking]');
      if (!root || navBtn.disabled || isCloseState()) return;
      const delta = navBtn.dataset.pitbCalNav === 'next' ? 1 : -1;
      const { minMonth, maxMonth } = calendarMonthBounds(root);
      const nextMonth = clampMonthKey(shiftMonthKey(getViewMonth(root), delta), minMonth, maxMonth);
      setViewMonth(root, nextMonth);
      renderCalendar(root);
      return;
    }

    const trigger = target.closest('[data-pitb-date-trigger]');
    if (trigger) {
      const root = trigger.closest('[data-pitb-booking]');
      if (!root || trigger.disabled || isCloseState() || isBookingProcessing()) return;
      const popup = root.querySelector('[data-pitb-date-popup]');
      if (popup && popup.classList.contains('is-open')) {
        closeDatePopup(root);
      } else {
        openDatePopup(root);
      }
      return;
    }

    const dayBtn = target.closest('[data-pitb-pickup-date-day]');
    if (dayBtn) {
      const root = dayBtn.closest('[data-pitb-booking]');
      if (!root) return;
      if (isBookingProcessing()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        applyAttrsToUi(lastCommittedAttrs);
        return;
      }
      if (isCloseState() || dayBtn.disabled || dayBtn.classList.contains('is-sold-out')) {
        event.preventDefault();
        refreshCapacity();
        return;
      }
      const iso = normalizeDate(dayBtn.dataset.pitbPickupDateDay);
      if (!iso || !isDateSelectable(iso, root)) return;
      const hidden = root.querySelector('[data-pitb-pickup-date]');
      if (hidden) hidden.value = iso;
      root.querySelectorAll('[data-pitb-timeslot]').forEach((input) => {
        input.checked = false;
      });
      closeDatePopup(root);
      save(root, { clearSlot: true }).then(() => {
        statusEls().forEach((status) => {
          if (!status || status.closest('#pitb-tickets')) return;
          status.hidden = false;
          status.textContent = HINTS.timeslot;
        });
        const timeslotWrap = root.querySelector('[data-pitb-timeslot-wrap]');
        if (timeslotWrap) timeslotWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeAllDatePopups();
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;
    const root = target.closest('[data-pitb-booking]');
    if (!root) return;

    if (isBookingProcessing()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      applyAttrsToUi(lastCommittedAttrs);
      return;
    }

    if (target.matches('[data-pitb-timeslot]')) {
      if (isCloseState()) {
        target.checked = false;
        target.disabled = true;
        refreshCapacity();
        return;
      }
      if (!readDateFromRoot(root)) {
        target.checked = false;
        syncCheckoutGate();
        return;
      }
      save(root);
    }
  });

  document.addEventListener(
    'click',
    (event) => {
      const booking = event.target && event.target.closest && event.target.closest('[data-pitb-booking]');
      if (!booking) return;

      const slot = event.target.closest('[data-pitb-slot-option]');
      const interactive = event.target.closest(
        '[data-pitb-date-trigger], [data-pitb-pickup-date-day], [data-pitb-date-close], [data-pitb-slot-option], [data-pitb-timeslot]'
      );
      if (!interactive) return;

      if (isCloseState()) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      if (isBookingProcessing()) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!target || !target.closest) return;
      const checkout =
        target.closest('button[name="checkout"]') ||
        target.closest('#CartDrawer-Checkout') ||
        target.closest('a[href="/checkout"]') ||
        target.closest('a[href*="/checkout"]');
      if (!checkout) return;

      const navigating =
        window.PITBCheckoutAuth &&
        typeof window.PITBCheckoutAuth.isNavigating === 'function' &&
        window.PITBCheckoutAuth.isNavigating();

      if (
        navigating ||
        isBookingProcessing() ||
        checkout.disabled ||
        checkout.classList.contains('loading') ||
        checkout.getAttribute('aria-disabled') === 'true'
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      if (event.defaultPrevented) return;
      const root = preferredRoot(checkout.closest('[data-pitb-booking]'));
      const ready = checkoutReadiness();
      if (!ready.ok) {
        event.preventDefault();
        event.stopImmediatePropagation();
        syncCheckoutGate();
        if (ready.reason === 'login' && window.PITBCheckoutAuth) {
          window.PITBCheckoutAuth.redirectToLogin();
          return;
        }
        const focusRoot = preferredRoot();
        if (focusRoot && (ready.reason === 'date' || ready.reason === 'timeslot' || ready.reason === 'full')) {
          focusRoot.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.beginNavigate === 'function') {
        window.PITBCheckoutAuth.beginNavigate();
      }
      setCheckoutLoading(true);

      save(root)
        .then((attrs) => {
          if (attrs === null) {
            if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.cancelNavigate === 'function') {
              window.PITBCheckoutAuth.cancelNavigate();
            }
            setCheckoutLoading(false);
            return null;
          }
          setCheckoutLoading(true);
          if (window.PITBCheckoutAuth && !window.PITBCheckoutAuth.canProceedToCheckout()) {
            window.PITBCheckoutAuth.redirectToLogin();
            return null;
          }
          if (window.PITBEntryFee && typeof window.PITBEntryFee.checkout === 'function') {
            return window.PITBEntryFee.checkout();
          }
          if (window.PITBEntryFee && typeof window.PITBEntryFee.ensure === 'function') {
            return window.PITBEntryFee.ensure().then(() => {
              if (window.PITBCheckoutAuth) window.PITBCheckoutAuth.proceedToCheckout('/checkout');
              else window.location.href = '/checkout';
            });
          }
          if (window.PITBCheckoutAuth) window.PITBCheckoutAuth.proceedToCheckout('/checkout');
          else window.location.href = '/checkout';
          return null;
        })
        .catch(() => {
          if (window.PITBCheckoutAuth && typeof window.PITBCheckoutAuth.cancelNavigate === 'function') {
            window.PITBCheckoutAuth.cancelNavigate();
          }
          setCheckoutLoading(false);
        });
    },
    true
  );

  const seedCatalogFromDom = (mode) => {
    if (!catalogRoot[mode]) catalogRoot[mode] = {};
    const dom = bookingRootDataset(mode);
    const cat = catalogRoot[mode];
    if (dom.dates.length) {
      const next = mergeIsoLists(cat.availableDates, dom.dates);
      cat.availableDates = next;
      if (!cat.dateMin || next[0] < cat.dateMin) cat.dateMin = next[0];
      if (!cat.dateMax || next[next.length - 1] > cat.dateMax) cat.dateMax = next[next.length - 1];
    }
    if (dom.slots.length && !(cat.slots || []).length) cat.slots = dom.slots;
  };

  const boot = () => {
    seedCatalogFromDom('event');
    seedCatalogFromDom('self_collect');
    applyCatalogMode(collectionModeFromDom());
    updateAllDateTriggers();
    renderAllCalendars();
    // First paint from Liquid catalog — don't hold the cart overlay for network refresh.
    if (typeof resolveBookingReady === 'function') {
      resolveBookingReady();
      resolveBookingReady = null;
    }

    // Background: refresh capacity in parallel (was serial event → self_collect).
    Promise.all([prefetchCatalogDates('event'), prefetchCatalogDates('self_collect')])
      .catch(() => {})
      .finally(() => {
        Promise.all([refreshTicketRemaining('event'), refreshTicketRemaining('self_collect')])
          .catch(() => {})
          .finally(() => {
            applyCatalogMode(collectionModeFromDom());
            renderAllCalendars();
            restoreFromCart({ persist: true });
          });
      });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) restoreFromCart();
  });

  // Refresh open calendars and invalidate saved selections across 8 PM/midnight.
  let lastPickupFloor = pickupPolicy.earliestPickupDate();
  const refreshPickupCutoff = () => {
    const floor = pickupPolicy.earliestPickupDate();
    if (floor === lastPickupFloor) return;
    lastPickupFloor = floor;
    renderAllCalendars();
    syncCheckoutGate();
    restoreFromCart({ persist: true });
  };
  setInterval(refreshPickupCutoff, 1000);
  window.addEventListener('focus', refreshPickupCutoff);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshPickupCutoff();
  });

  document.addEventListener('cart:updated', () => {
    setTimeout(() => {
      refreshCapacityFromTickets();
      restoreFromCart();
    }, 80);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && Array.isArray(event.cartData.items)) {
        lastCart = event.cartData;
        syncCheckoutGate();
      }
      setTimeout(() => {
        refreshCapacityFromTickets();
        restoreFromCart();
        if (window.PITBEntryFee && typeof window.PITBEntryFee.ensure === 'function') {
          window.PITBEntryFee.ensure();
        }
      }, 80);
    });
  }

  const selectionValidForCatalog = (date, slot) => {
    const iso = normalizeDate(date);
    const key = normalizeSlot(slot);
    if (!iso || !key) return false;
    if (!isDateSelectable(iso, preferredRoot())) return false;
    if (isDateSoldOut(iso)) return false;
    const slots = activeCatalog().slots || [];
    if (slots.length && !slots.some((entry) => normalizeSlot(entry) === key)) return false;
    return remainingForSlot(iso, key) > 0;
  };

  const syncSlotLists = (slots, selectedSlot, groupSeed) => {
    const list = Array.isArray(slots)
      ? slots.map((slotLabel) => normalizeSlot(slotLabel)).filter(Boolean)
      : [];
    const selected = normalizeSlot(selectedSlot);
    const listSet = new Set(list);

    allRoots().forEach((root, index) => {
      const slotList = root.querySelector('[data-pitb-slot-list]');
      if (!slotList) return;
      const existing = slotList.querySelector('[data-pitb-timeslot]');
      const groupName = (existing && existing.name) || `${groupSeed || 'pitb-slot'}-${index + 1}`;
      const date = normalizeDate(readDateFromRoot(root));
      const closed = isCloseState();

      slotList.querySelectorAll('[data-pitb-slot-option]').forEach((labelEl) => {
        const key = normalizeSlot(labelEl.getAttribute('data-pitb-slot-option'));
        if (!listSet.has(key)) labelEl.remove();
      });

      list.forEach((key) => {
        let labelEl = Array.from(slotList.querySelectorAll('[data-pitb-slot-option]')).find(
          (el) => normalizeSlot(el.getAttribute('data-pitb-slot-option')) === key
        );
        if (!labelEl) {
          labelEl = document.createElement('label');
          labelEl.className = 'pitb-booking__slot';
          labelEl.setAttribute('data-pitb-slot-option', key);
          const input = document.createElement('input');
          input.type = 'radio';
          input.name = groupName;
          input.value = key;
          input.setAttribute('data-pitb-timeslot', '');
          const text = document.createElement('span');
          text.setAttribute('data-pitb-slot-label', '');
          labelEl.appendChild(input);
          labelEl.appendChild(text);
        }
        const input = labelEl.querySelector('[data-pitb-timeslot]');
        const text = labelEl.querySelector('[data-pitb-slot-label]');
        if (input) {
          input.name = groupName;
          input.checked = selected === key;
          input.disabled = closed || !date;
        }
        if (text) text.textContent = key.replace(/–/g, ' - ');
        slotList.appendChild(labelEl);
      });
    });
  };

  const switchCollectionMethod = async (method) => {
    const nextMode = method === 'self_collect' ? 'self_collect' : 'event';
    setBookingProcessing(true);
    if (window.PITBEntryFee && typeof window.PITBEntryFee.setCartPageSyncing === 'function') {
      window.PITBEntryFee.setCartPageSyncing(true);
    }
    if (window.PITBEntryFee && typeof window.PITBEntryFee.showLoading === 'function') {
      window.PITBEntryFee.showLoading();
    }
    // Update estimated total immediately on Visit ↔ Self-collect (before date/slot).
    if (window.PITBEntryFee && typeof window.PITBEntryFee.syncEstimatedTotals === 'function') {
      window.PITBEntryFee.syncEstimatedTotals(nextMode);
    }

    try {
      applyCatalogMode(nextMode);
      const cat = catalogRoot[nextMode] || {};
      const nextSlots = (
        Array.isArray(cat.slots) && cat.slots.length ? cat.slots : bookingRootDataset(nextMode).slots
      )
        .map(normalizeSlot)
        .filter(Boolean);
      if (nextSlots.length) syncSlotLists(nextSlots, '', 'pitb-slot');

      const productHandle = catalogHandleForMode(nextMode);
      allRoots().forEach((root) => {
        if (productHandle) root.setAttribute('data-pitb-booking-product', productHandle);
      });

      applyAttrsToUi({ pitb_pickup_date: '', pitb_timeslot: '' });
      renderAllCalendars();
      allRoots().forEach(applyCapacityUi);
      syncCheckoutGate();

      const attrs = checkoutAttributes({
        pitb_pickup_date: '',
        pitb_timeslot: '',
        pitb_collection_method: nextMode === 'self_collect' ? 'self_collect' : 'event',
      });

      // Parallel: one cart write (tickets + attrs) + capacity refresh for the target mode.
      // Both must finish before unlock so the calendar is not stale.
      const cartSwitch =
        window.PITBEntryFee && typeof window.PITBEntryFee.applyCollectionSwitch === 'function'
          ? window.PITBEntryFee.applyCollectionSwitch(
              nextMode === 'self_collect' ? 'self_collect' : 'event',
              attrs
            )
          : (async () => {
              await fetch('/cart/update.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ attributes: attrs }),
              });
              if (window.PITBEntryFee && typeof window.PITBEntryFee.sync === 'function') {
                await window.PITBEntryFee.sync({ addIfMissing: false, showLoading: false });
              }
            })();

      await Promise.all([cartSwitch, refreshTicketRemaining(nextMode)]);

      renderAllCalendars();
      allRoots().forEach(applyCapacityUi);
      syncCheckoutGate();
      if (window.PITBEntryFee && typeof window.PITBEntryFee.syncEstimatedTotals === 'function') {
        window.PITBEntryFee.syncEstimatedTotals(nextMode);
      }
    } finally {
      if (window.PITBEntryFee && typeof window.PITBEntryFee.hideLoading === 'function') {
        window.PITBEntryFee.hideLoading();
      }
      if (window.PITBEntryFee && typeof window.PITBEntryFee.setCartPageSyncing === 'function') {
        window.PITBEntryFee.setCartPageSyncing(false);
      }
      setBookingProcessing(false);
    }
  };

  window.PITBBooking = {
    current,
    save,
    restoreFromCart,
    applyAttrsToUi,
    refreshCapacity,
    syncCheckoutGate,
    checkoutReadiness,
    remainingForSlot,
    ticketKey,
    normalizeDate,
    noteCart: (cart) => {
      if (cart && Array.isArray(cart.items)) lastCart = cart;
    },
    canCheckout: () => checkoutReadiness().ok,
    isBookingProcessing,
    setBookingProcessing,
    switchCollectionMethod,
    applyCatalogMode,
    whenReady: bookingReadyPromise,
  };
})();
